import { SxProps } from '@mui/material';
import { Fonts } from 'common-types';

export const BOTTOM_TAB_BAR_WRAPPER_PB = 8; // 32px
export const BOTTOM_TAB_BAR_HEIGHT = 56; // px
export const BOTTOM_TAB_BAR_TOTAL_HEIGHT_PX = BOTTOM_TAB_BAR_WRAPPER_PB * 4 + BOTTOM_TAB_BAR_HEIGHT; // 88px, for CSS `bottom` (raw px)
export const BOTTOM_TAB_BAR_OFFSET = 24; // MUI spacing units for pb/mb to clear tab bar (96px)

export const wrapperSx: SxProps = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
  pb: BOTTOM_TAB_BAR_WRAPPER_PB,
  zIndex: 1000,
  pointerEvents: 'none',
};

export const tabBarSx: SxProps = {
  width: 'calc(100% - 48px)',
  maxWidth: 390,
  height: BOTTOM_TAB_BAR_HEIGHT,
  borderRadius: '64px',
  px: 3,
  py: 4,
  backgroundColor: 'common.white',
  boxShadow: '0 0 20px 0 rgba(131, 131, 131, 0.10)',
  pointerEvents: 'auto',
  position: 'relative',
  overflow: 'hidden',
};

export const tabItemSx: SxProps = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  pb: '5px',
  textDecoration: 'none',
  color: '#0F0F0F',
  fontFamily: Fonts.ABC_ORACLE,
  fontWeight: 500,
  fontSize: 14,
  whiteSpace: 'nowrap',
};

export const profileAvatarSx: SxProps = {
  width: 36,
  height: 36,
  borderRadius: '50%',
  overflow: 'hidden',
  display: 'block',
  textDecoration: 'none',
  ml: 2,
  flexShrink: 0,
};

export const tabIndicatorSx = (isActive: boolean): SxProps => ({
  position: 'absolute',
  bottom: 0,
  left: '50%',
  width: 13,
  height: 3,
  borderRadius: '4px',
  backgroundColor: '#0F0F0F',
  transform: isActive ? 'translateX(-50%) scaleX(1)' : 'translateX(-50%) scaleX(0)',
  transformOrigin: 'center',
  transition: 'transform 0.3s ease',
});
